import { useCallback } from "react";
import { generatePath, useNavigate } from "react-router";

import { QUERY_PARAMS } from "@/routes/_constants";
import { PATHS } from "@/routes/paths";

export const useTransitions = (hotelID: string) => {
	const navigate = useNavigate();

	/**
	 * 通常ディスカウントの追加ページへ遷移する
	 */
	const onTransitionToAddOrdinaryDiscount = useCallback(() => {
		navigate(
			generatePath(PATHS.HOTEL.ITEMS.DISCOUNT.NEW, {
				hotelID,
				type: QUERY_PARAMS.ITEMS.DISCOUNT.TYPE.ORDINARY,
			}),
		);
	}, [hotelID, navigate]);
	/**
	 * 通常ディスカウントの編集ページへ遷移する
	 */
	const onTransitionToEditOrdinaryDiscount = useCallback(
		(discountID: string) => {
			navigate(
				generatePath(PATHS.HOTEL.ITEMS.DISCOUNT.EDIT, {
					hotelID,
					type: QUERY_PARAMS.ITEMS.DISCOUNT.TYPE.ORDINARY,
					discountID,
				}),
			);
		},
		[hotelID, navigate],
	);
	/**
	 * 通常ディスカウントの複製ページへ遷移する
	 */
	const onTransitionToDuplicateOrdinaryDiscount = useCallback(
		(duplicateDiscountID: string) => {
			navigate(
				generatePath(PATHS.HOTEL.ITEMS.DISCOUNT.DUPLICATE, {
					hotelID,
					type: QUERY_PARAMS.ITEMS.DISCOUNT.TYPE.ORDINARY,
					duplicateDiscountID,
				}),
			);
		},
		[hotelID, navigate],
	);

	/**
	 * 連泊ディスカウントの追加ページへ遷移する
	 */
	const onTransitionToAddLongTermStayDiscount = useCallback(() => {
		navigate(
			generatePath(PATHS.HOTEL.ITEMS.DISCOUNT.NEW, {
				hotelID,
				type: QUERY_PARAMS.ITEMS.DISCOUNT.TYPE.LONG_TERM_STAY,
			}),
		);
	}, [hotelID, navigate]);
	/*
	 * 連泊ディスカウントの編集ページへ遷移する
	 */
	const onTransitionToEditLongTermStayDiscount = useCallback(
		(discountID: string) => {
			navigate(
				generatePath(PATHS.HOTEL.ITEMS.DISCOUNT.EDIT, {
					hotelID,
					type: QUERY_PARAMS.ITEMS.DISCOUNT.TYPE.LONG_TERM_STAY,
					discountID,
				}),
			);
		},
		[hotelID, navigate],
	);
	/**
	 * 連泊ディスカウントの複製ページへ遷移する
	 */
	const onTransitionToDuplicateLongTermStayDiscount = useCallback(
		(duplicateDiscountID: string) => {
			navigate(
				generatePath(PATHS.HOTEL.ITEMS.DISCOUNT.DUPLICATE, {
					hotelID,
					type: QUERY_PARAMS.ITEMS.DISCOUNT.TYPE.LONG_TERM_STAY,
					duplicateDiscountID,
				}),
			);
		},
		[hotelID, navigate],
	);

	/**
	 * 複合ディスカウントの追加ページへ遷移する
	 */
	const onTransitionToAddMultiDiscount = useCallback(() => {
		navigate(
			generatePath(PATHS.HOTEL.ITEMS.DISCOUNT.NEW, {
				hotelID,
				type: QUERY_PARAMS.ITEMS.DISCOUNT.TYPE.MULTI,
			}),
		);
	}, [hotelID, navigate]);
	/**
	 * 複合ディスカウントの編集ページへ遷移する
	 */
	const onTransitionToEditMultiDiscount = useCallback(
		(discountID: string) => {
			navigate(
				generatePath(PATHS.HOTEL.ITEMS.DISCOUNT.EDIT, {
					hotelID,
					type: QUERY_PARAMS.ITEMS.DISCOUNT.TYPE.MULTI,
					discountID,
				}),
			);
		},
		[hotelID, navigate],
	);
	/**
	 * 複合ディスカウントの複製ページへ遷移する
	 */
	const onTransitionToDuplicateMultiDiscount = useCallback(
		(duplicateDiscountID: string) => {
			navigate(
				generatePath(PATHS.HOTEL.ITEMS.DISCOUNT.DUPLICATE, {
					hotelID,
					type: QUERY_PARAMS.ITEMS.DISCOUNT.TYPE.MULTI,
					duplicateDiscountID,
				}),
			);
		},
		[hotelID, navigate],
	);

	return {
		// ordinary
		onTransitionToAddOrdinaryDiscount,
		onTransitionToEditOrdinaryDiscount,
		onTransitionToDuplicateOrdinaryDiscount,

		// longTermStay
		onTransitionToAddLongTermStayDiscount,
		onTransitionToEditLongTermStayDiscount,
		onTransitionToDuplicateLongTermStayDiscount,

		// multi
		onTransitionToAddMultiDiscount,
		onTransitionToEditMultiDiscount,
		onTransitionToDuplicateMultiDiscount,
	};
};
